function normalizeId(value) {
  if (value == null || value === '') {
    return null
  }

  return String(value)
}

function normalizeName(value) {
  return (value ?? '').toString().trim().toLowerCase()
}

function getSpellCharacterRuneId(spell) {
  const sourceLabel = normalizeName(spell?.source)

  return (
    spell?.character_rune ??
    spell?.character_rune_id ??
    (sourceLabel === 'rune' ? (spell?.source_id ?? null) : null)
  )
}

function getSpellSecondaryRuneId(spell) {
  return spell?.secondary_rune ?? spell?.secondary_rune_id ?? null
}

function getRuneStaticId(rune) {
  return rune?.rune ?? rune?.rune_id ?? null
}

function isRuneSpell(spell) {
  return (
    normalizeName(spell?.source) === 'rune' ||
    normalizeName(spell?.type) === 'rune' ||
    getSpellCharacterRuneId(spell) != null ||
    getSpellSecondaryRuneId(spell) != null ||
    normalizeName(spell?.casting_rune_name) !== '' ||
    normalizeName(spell?.secondary_rune_name) !== ''
  )
}

export default function getLinkedRuneSpellEntries({ character, rune } = {}) {
  const spells = Array.isArray(character?.spells) ? character.spells : []

  if (!rune) {
    return []
  }

  const runeId = normalizeId(rune.id)
  const runeName = normalizeName(rune.name)
  const runeStaticId = normalizeId(getRuneStaticId(rune))

  return spells
    .filter((spell) => isRuneSpell(spell))
    .map((spell) => {
      const relations = []
      const spellCharacterRuneId = normalizeId(getSpellCharacterRuneId(spell))
      const spellCastingRuneName = normalizeName(spell?.casting_rune_name)
      const spellSecondaryRuneId = normalizeId(getSpellSecondaryRuneId(spell))
      const spellSecondaryRuneName = normalizeName(spell?.secondary_rune_name)

      const matchesCasting =
        (spellCharacterRuneId != null && runeId != null && spellCharacterRuneId === runeId) ||
        (spellCharacterRuneId == null && runeName !== '' && spellCastingRuneName === runeName)

      const matchesSecondary =
        (spellSecondaryRuneId != null &&
          runeStaticId != null &&
          spellSecondaryRuneId === runeStaticId) ||
        (spellSecondaryRuneId == null && runeName !== '' && spellSecondaryRuneName === runeName)

      if (matchesCasting) {
        relations.push('casting rune')
      }

      if (matchesSecondary) {
        relations.push('secondary rune')
      }

      if (relations.length === 0) {
        return null
      }

      const spellLabel = spell?.display_name || spell?.name || 'Unnamed Spell'

      return {
        spell,
        relations,
        label: `${spellLabel} (${relations.join(', ')})`,
      }
    })
    .filter(Boolean)
}
